import * as yup from "yup";
import { TemperatureUnits } from "../generated/graphqlTypes";
export var UserPreferencesSchema;
(function (UserPreferencesSchema) {
    UserPreferencesSchema.Schema = yup.object().shape({
        temperatureUnits: yup
            .string()
            .required()
            .oneOf([TemperatureUnits.Celsius, TemperatureUnits.Fahrenheit]),
    });
    UserPreferencesSchema.DefaultUserPreferences = {
        temperatureUnits: TemperatureUnits.Celsius,
    };
    function UserPreferencesIsEqual(lhs, rhs) {
        return lhs.temperatureUnits === rhs.temperatureUnits;
    }
    UserPreferencesSchema.UserPreferencesIsEqual = UserPreferencesIsEqual;
})(UserPreferencesSchema || (UserPreferencesSchema = {}));
//# sourceMappingURL=UserPreferencesSchema.js.map